import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsInvestigatorConnection } from '../../../../types/types';
import { IGqlBaseOptions } from '../../../../interfaces';
import { investigationMetricsInvestigatorConnection } from './investigation-metrics-investigator.operations';
import { connectionQuery } from '../../../../helpers.class';

@Injectable()
export class GqlInvestigationMetricsInvestigatorService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsInvestigatorConnection> {
    return this.apollo.query(connectionQuery(investigationMetricsInvestigatorConnection, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
